module.exports = __webpack_public_path__ + "static/media/thtplus-vip-banner.5c0fef89.jpg";